import React from 'react';
import { Table, Empty, Form, Input, Tooltip, Button } from 'antd';
export default class Series extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    render() {
        debugger;
        return (
            <Table
                className={'compra-table-serie'}
                scroll={{ x: true }}
                size="small"
                style={{ overflowX: 'auto' }}
                pagination={false}
                dataSource={this.props.dataSource}
                rowKey={record => record.identifier}
                locale={{
                    emptyText: <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description='No se encontraron datos.'
                    />
                }}
                columns={[
                    // {
                    //     title: 's',
                    //     width: 0,
                    //     dataIndex: '',
                    //     key: ''
                    // }, 
                    {
                        key: 'remove-button',
                        align: 'center',
                        width: 80,
                        fixed: 'left',
                        render: (value, row) => (
                            <span>
                                <div className="custom-options">
                                    <Tooltip placement="top" title="Remover Serie">
                                        <Button
                                            type="danger"
                                            icon="delete"
                                            size={"small"}
                                            // onClick={() => props.onRemove(row)}
                                        />
                                    </Tooltip>
                                </div>
                            </span>
                        )
                    },
                    {
                        title: 'Serie',
                        width: 250,
                        dataIndex: 'serie',
                        fixed: 'left',
                        // ellipsis: true,
                        key: 'serie',
                        // className: mostrarLoteProducto ? 'show' : 'hide',
                        align: 'center',
                        render: (value, row) => {
                            return (
                                // <Form.Item className={mostrarLoteProducto ? 'show' : 'hide'}>
                                <Form.Item>
                                    {this.props.onGetFieldDecorator(`arrSerie[${row.identifier}]`, {
                                        initialValue: value
                                    })(
                                        <Input
                                            placeholder="serie"
                                            autoComplete="off"
                                            className="text-left"
                                            // onBlur={(e) => props.onCalculateDetail(row, "arrLote", e.target.value, 0)}
                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    },
                    {
                        title: 'Serie',
                        width: 250,
                        dataIndex: 'serie',
                        // fixed: 'left',
                        // ellipsis: true,
                        key: 'serie',
                        // className: mostrarLoteProducto ? 'show' : 'hide',
                        align: 'center',
                        render: (value, row) => {
                            return (
                                // <Form.Item className={mostrarLoteProducto ? 'show' : 'hide'}>
                                <Form.Item>
                                    {this.props.onGetFieldDecorator(`arrSerie[${row.identifier}]`, {
                                        initialValue: value
                                    })(
                                        <Input
                                            placeholder="serie"
                                            autoComplete="off"
                                            className="text-left"
                                            // onBlur={(e) => props.onCalculateDetail(row, "arrLote", e.target.value, 0)}
                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    }
                ]}
            />
        );
    }
}